/* tslint:disable */
/* eslint-disable */
/**
 * RaidSIMP OpenAPI Spec
 * Manage your raid teams, enhanced with data from the Blizzard API.
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RenameRaidTeamDto
 */
export interface RenameRaidTeamDto {
    /**
     * 
     * @type {string}
     * @memberof RenameRaidTeamDto
     */
    name: string;
}

export function RenameRaidTeamDtoFromJSON(json: any): RenameRaidTeamDto {
    return RenameRaidTeamDtoFromJSONTyped(json, false);
}

export function RenameRaidTeamDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenameRaidTeamDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function RenameRaidTeamDtoToJSON(value?: RenameRaidTeamDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


